// extracted by mini-css-extract-plugin
module.exports = {"textLogo1":"navigation_textLogo1__3r3KP","learnMore":"navigation_learnMore__2Qd9g"};